/**
 * Convierte un array de objetos con latitude/longitude a formato [lat, lng]
 *
 * @param route Lista de puntos con `{ latitude, longitude }`
 * @returns Lista de coordenadas como `[number, number][]`
 */
export function adaptCoordsToPolygon(
  coordinates: { latitude: number; longitude: number }[]
): [number, number][] {
  return coordinates.map((coord) => [coord.latitude, coord.longitude]);
}
